import type { IFeatureFlagsProvider } from './FeatureFlagsProvider'
import { StaticFeatureFlagsProvider } from './staticFeatureFlags'

/**
 * Returns the active feature-flags provider.
 * Switch implementation here (env, remote config, etc.); see README.md in this folder.
 */
export function createFeatureFlagsProvider(): IFeatureFlagsProvider {
  return new StaticFeatureFlagsProvider()
}
